import { useMarkConversationEscalated } from '@cascade/react/conversations';
import * as tickets from '@cascade/react/tickets';
import { useUser } from '@cascade/react/user';
import { usePathSegment } from '@cascade/react-dom/hooks';
import type { PropsWithChildren } from 'react';
import { useMatch } from 'react-router-dom';
import { TICKET_PATH, TICKETS_PATH } from '#config/index.ts';

const TICKETS_PAGE_SIZE = 100;

export const TicketsProvider = ({ children }: PropsWithChildren) => {
  const { user } = useUser();
  const markConversationEscalated = useMarkConversationEscalated();
  const ticketsMatch = useMatch(`/${TICKETS_PATH}`);

  const { value: displayId } = usePathSegment({
    path: `/${TICKET_PATH}`,
    fallbackPath: `/${TICKETS_PATH}`,
  });

  const list = ticketsMatch
    ? { page_size: TICKETS_PAGE_SIZE, filter_reporter_id: user?.id }
    : undefined;

  return (
    <tickets.TicketsProvider
      list={list}
      displayId={displayId}
      onConversationEscalated={markConversationEscalated}
    >
      {children}
    </tickets.TicketsProvider>
  );
};
